module.exports = __webpack_public_path__ + "static/img/bc1-2.55ae7d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/bc1-2.png
// module id = 818
// module chunks = 0